import React from "react";
import { Link } from "react-router-dom";
import "../styles/MamahoodHomepage.css";

const episodes = [
  {
    slug: "episode-2-hello-shradha-sud",
    title: "Hello, Shradha Sud, the Founder of Akara!",
    date: "1/9/25",
    image:
      "https://images.squarespace-cdn.com/content/v1/640a9c0e94995c4a51189d55/1736452207752-MF4KM1KK7AEJHXDBOXWF/ShradhaSud_VoyeurpreneurCover.png",
    excerpt: "Heather Anderson",
  },
  {
    slug: "epidsode-01",
    title: "Hello, Mya Papolu, the innovative founder of Brandbass!",
    date: "1/9/24",
    image:
      "https://images.squarespace-cdn.com/content/v1/640a9c0e94995c4a51189d55/1707166555719-5D0BOKD289IZPACR66T3/MyaPapolu_Headshot.png",
    excerpt:
      "As part of our quick, bingeable HELLO series, we get to meet Mya Papolu, the innovative founder of Brandbass, as she transforms the world of content creation and influencer marketing.",
  },
  {
    slug: "epidsode-01-mrxdz",
    title: "Introducing Voyeurpreneur",
    date: "1/8/24",
    image:
      "https://images.squarespace-cdn.com/content/v1/640a9c0e94995c4a51189d55/1705703209725-OTRJ53ZSIZYG4QKV6ZF5/IntroductionCover.png",
    excerpt:
      "Welcome to 'Voyeurpreneur' – a show about diving deep into the entrepreneurial journey, where we unravel the real stories of innovation, resilience, and success from the most inspiring business minds.",
  },
];

const SPOTIFY_SHOW_URL = "https://open.spotify.com/show/5BuXWwu0cfQbBEwtYght9C";
const SPOTIFY_BADGE_URL =
  "https://images.squarespace-cdn.com/content/v1/640a9c0e94995c4a51189d55/e00f300c-7a4d-493f-8fda-dee7ee70744f/spotify-podcast-badge-wht-blk-165x40.png";
const HERO_IMAGE_URL =
  "https://images.squarespace-cdn.com/content/v1/640a9c0e94995c4a51189d55/1705704902962-ISLNTTGZT3HF3UJM9KUI/IntroductionCover.png";
const FEATURED_IMAGE_URL =
  "https://images.squarespace-cdn.com/content/v1/640a9c0e94995c4a51189d55/1707166555719-5D0BOKD289IZPACR66T3/MyaPapolu_Headshot.png";
const AUDIO_SRC =
  "https://static1.squarespace.com/static/640a9c0e94995c4a51189d55/t/65ac2e0caa7cf51a7ae57449/1705081057677/MyaPapolu_Teaser_FinalMix_V3.m4a/original/MyaPapolu_Teaser_FinalMix_V3.m4a";

export default function PodcastsPage() {
  return (
    <main className="mh-site">
      <section className="section-light">
        <div className="mh-podcast-hero">
          <div className="mh-podcast-hero__image">
            <img src={HERO_IMAGE_URL} alt="Voyeurpreneur podcast cover" />
          </div>
          <div className="mh-podcast-hero__content">
            <h1>VOYEURPRENEUR</h1>
            <p>
              Peek behind the curtains with us through inspiring and authentic
              conversations with innovators, entrepreneurs, and idealists, as
              they share the real grit and glory of the brands and movements
              they&apos;re building.
            </p>
            <a
              className="mh-pill mh-pill--gold"
              href={SPOTIFY_SHOW_URL}
              target="_blank"
              rel="noreferrer"
            >
              Listen on Spotify
            </a>
          </div>
        </div>
      </section>

      <section className="mh-podcast-signup">
        <div className="mh-container">
          <h2>Join the Voyeurpreneur Community</h2>
          <p>Stay updated with new episodes, sneak peeks, and more.</p>
          <form
            className="mh-podcast-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <input type="text" name="name" placeholder="Name" aria-label="Name" />
            <input type="email" name="email" placeholder="Email" aria-label="Email" />
            <button type="submit" className="mh-pill mh-pill--gold">Submit</button>
          </form>
        </div>
      </section>

      <section className="section-light">
        <div className="mh-podcast-featured">
          <div className="mh-podcast-featured__image">
            <img src={FEATURED_IMAGE_URL} alt="Mya Papolu" />
          </div>
          <div className="mh-podcast-featured__content">
            <p className="mh-podcast-featured__label">
              LISTEN TO MY LATEST PODCAST EPISODE:
            </p>
            <audio controls preload="none">
              <source src={AUDIO_SRC} type="audio/mp4" />
              Your browser does not support the audio element.
            </audio>
            <a
              href={SPOTIFY_SHOW_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Listen on Spotify"
            >
              <img src={SPOTIFY_BADGE_URL} alt="Listen on Spotify" />
            </a>
          </div>
        </div>
      </section>

      <section className="mh-podcast-episodes">
        <h2>Episodes</h2>
        <div className="mh-podcast-episodes__grid">
          {episodes.map((episode) => (
            <article className="mh-podcast-episode-card" key={episode.slug}>
              <Link to={`/twentytwentysix/podcasts/${episode.slug}`}>
                <img src={episode.image} alt={episode.title} />
              </Link>
              <div className="mh-podcast-episode-card__body">
                <p className="mh-podcast-episode-card__meta">
                  Heather Anderson · {episode.date}
                </p>
                <h3>
                  <Link to={`/twentytwentysix/podcasts/${episode.slug}`}>
                    {episode.title}
                  </Link>
                </h3>
                <p>{episode.excerpt}</p>
                <Link
                  className="mh-podcast-read-more"
                  to={`/twentytwentysix/podcasts/${episode.slug}`}
                >
                  Read More
                </Link>
              </div>
            </article>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <Link to="/twentytwentysix" className="mh-link-row">
            Back to Home
          </Link>
        </div>
      </section>
    </main>
  );
}
